module.exports = __webpack_public_path__ + "assets/b78af78650ded6829a7255db9c364b67.jpg";